export const ADMIN_ROLES = [
  'super_admin',
  'admin',
  'finance_manager',
  'operations_manager',
  'management_viewer',
] as const;

export type AdminRole = (typeof ADMIN_ROLES)[number];

export const ADMIN_ROLE_LABELS: Record<AdminRole, string> = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  finance_manager: 'Finance Manager',
  operations_manager: 'Operations Manager',
  management_viewer: 'Management Viewer',
};

/** Roles that can log in but are NOT full admins (view-only or scoped) */
export const SCOPED_ROLES: AdminRole[] = [
  'finance_manager',
  'operations_manager',
  'management_viewer',
];